// extracted by mini-css-extract-plugin
export const pin = "pin-module--pin--dpKBs";
export const bounce = "pin-module--bounce--1In1b";
export const pulse = "pin-module--pulse--1HvPd";
export const pulsate = "pin-module--pulsate--34-xR";